import {
  Container, Grid, Box, Typography, Button
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useStyles } from './style';

export const CardView = () => {
  const classes = useStyles();
  const history = useHistory();

  const allowCameraHandler = () => {
    history.push('/card-front');
  };

  const onSkipHandler = () => {
    history.push('/download-guide');
  };

  return (
    <Container maxWidth="md">
      <Box className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <Box className={classes.cardImageWrapper}>
              <Box component="img" src="assets/images/insurancecard.svg" className={classes.cardImage} />
            </Box>
            <Box className={classes.cardInfoTextWrapper}>
              <Typography variant="body1" className={classes.cardInfoText}>
                To protect your privacy and health information and avoid delays in processing your results, please submit a photo of the insurance card used to complete this form.
              </Typography>
            </Box>
            <Box className={classes.root}>
              <Grid container rowSpacing={{ xs: 3, sm: 2, md: 4 }}>
                <Grid item xs={12} md={6} className={classes.secondaryBtnWrapper}>
                  <Box px={2}>
                    <Button variant="contained" color="primary" onClick={allowCameraHandler}>
                      Take Photo
                    </Button>
                  </Box>

                </Grid>
                <Grid item xs={12} md={6} className={classes.primaryBtnWrapper}>
                  <Box px={2}>
                    <Button variant="contained" color="secondary" onClick={onSkipHandler}>
                      Skip
                    </Button>
                  </Box>

                </Grid>
              </Grid>
            </Box>
            <Box className={classes.root}>
              <Grid container spacing={{ xs: 3, sm: 2, md: 4 }}>
                <Grid item xs={12} md={12}>
                  <Typography variant="body2" className={classes.cardInfoText}>If you decide to skip, this photo will be taken at your first collection instead.</Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

    </Container>
  );
};
